import { Component, languages } from "../../../utils/modules";
import { selectFocus, selectBlur } from "../../../utils/functions.js";
class Lang extends Component {
  render() {
    return (
      <>
        <label
          htmlFor="lang-switch"
          className="d-flex position-relative justify-content-between align-items-center py-2 rounded border border-2"
        >
          <svg
            fill="none"
            height="15"
            width="14"
            xmlns="http://www.w3.org/2000/svg"
            className="mx-1"
            aria-hidden="true"
          >
            <path
              clipRule="evenodd"
              d="M7.438 14.114v.013h-.875v-.013a6.988 6.988 0 01-5.025-2.608l-.16-.207A6.964 6.964 0 01.014 7.565H0v-.876h.013A6.96 6.96 0 011.1 3.36l.125-.188A6.99 6.99 0 016.563.14V.126h.875V.14a6.987 6.987 0 015.016 2.599l.167.216a6.964 6.964 0 011.366 3.735H14v.874l-.013.001a6.959 6.959 0 01-1.072 3.306l-.14.213c-.061.09-.125.178-.191.265l-.16.203-.22.256a6.982 6.982 0 01-4.766 2.306zm-3.043-3.252l-.136.027c.57 1.249 1.402 2.1 2.304 2.312v-2.568c-.646.02-1.26.08-1.831.17zm3.043 2.339v-2.568l.352.015c.696.037 1.353.121 1.95.241-.568 1.248-1.4 2.1-2.302 2.312zm-4.042-2.105l-.105.03c-.253.075-.49.156-.71.242a6.15 6.15 0 001.709 1.253 6.765 6.765 0 01-.894-1.525zm7.15.132l.059-.132c.292.083.564.174.813.273a6.16 6.16 0 01-1.707 1.253c.316-.4.598-.87.835-1.394zM2.633 7.565H.89a6.092 6.092 0 001.114 3.106c.33-.149.694-.281 1.086-.397a10.405 10.405 0 01-.457-2.709zm8.734 0h1.743a6.089 6.089 0 01-1.113 3.105 8.574 8.574 0 00-1.088-.395c.26-.823.42-1.74.458-2.71zm-4.805 0H3.51c.038.904.191 1.748.43 2.494.801-.17 1.687-.276 2.623-.301zm.875 0h3.054a9.477 9.477 0 01-.43 2.494c-.801-.17-1.687-.276-2.622-.301zm-5.434-3.98l-.046.064A6.091 6.091 0 00.89 6.69h1.743c.038-.97.199-1.886.458-2.71a8.555 8.555 0 01-1.088-.395zm1.887.77l.05-.16c.8.17 1.686.276 2.622.301V6.69H3.51c.035-.84.17-1.627.38-2.333zm8.106-.772l-.115.052c-.3.127-.624.243-.972.345.26.823.42 1.74.458 2.71h1.743a6.092 6.092 0 00-1.114-3.107zm-2.187.662l.251-.05c.24.746.393 1.59.43 2.495H7.438l.002-2.194c.838-.023 1.637-.11 2.37-.25zm-5.455-1.08l-.095.2c.698.14 1.476.231 2.304.256V1.053c-.853.2-1.644.973-2.209 2.112zm3.084.456V1.053c.901.212 1.734 1.064 2.303 2.312a13.91 13.91 0 01-2.303.256zM9.71 1.633l.055.068c.32.42.603.91.84 1.457.292-.083.565-.174.814-.272A6.15 6.15 0 009.71 1.633zm-5.448.013l.027-.014a6.826 6.826 0 00-.894 1.526 8.63 8.63 0 01-.813-.273 6.144 6.144 0 011.68-1.239z"
              fill="#000"
              fillOpacity="0.45"
              fillRule="evenodd"
            ></path>
          </svg>
          <select
            name="lang"
            onFocus={selectFocus}
            onBlur={selectBlur}
            id="lang-switch"
            title={["Choose Language"].toString()}
            className="bg-transparent px-4 position-absolute top-0 left-0 w-100 h-100 border-0"
          >
            {languages.map((lang, i) => {
              return (
                <option
                  key={`index-${i}`}
                  value={lang.toString().toLowerCase().slice(0, 2)}
                >
                  {lang}
                </option>
              );
            })}
          </select>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="12"
            className="mx-2"
          >
            <path d="M3 0l3 5H0zm0 12L0 7h6z" fill="currentColor"></path>
          </svg>
        </label>
      </>
    );
  }
}

export default Lang;
